import * as React from 'react';
import {FunctionComponent} from 'react';
import {Week} from './Week';
import {startOfWeek} from 'date-fns';
import {classNames} from '../../../../Support/classNames';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {ca} from 'date-fns/locale';

interface OwnProps {
    referenceDate: Date;
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCreateClick: (date: Date) => void;
    className?: string;
}

export const WeeklyCalendar: FunctionComponent<OwnProps> = ({
    referenceDate,
    calendarEvents,
    onCalendarEventClick,
    onCreateClick,
    className,
}) => {
    const week: Array<{
        number: number;
        date: Date;
    }> = [];

    const firstDayInWeek = startOfWeek(referenceDate, {
        weekStartsOn: 1,
    });
    for (let i = 0; i < 7; i++) {
        week.push({
            number: firstDayInWeek.getDate() + i,
            date: new Date(firstDayInWeek.getFullYear(), firstDayInWeek.getMonth(), firstDayInWeek.getDate() + i),
        });
    }

    return (
        <div className={classNames('calendar-week', className)}>
            <div className="week">
                <div className="days">
                    <div className="week__header">Monday</div>
                    <div className="week__header">Tuesday</div>
                    <div className="week__header">Wednesday</div>
                    <div className="week__header">Thursday</div>
                    <div className="week__header">Friday</div>
                    <div className="week__header">Saturday</div>
                    <div className="week__header">Sunday</div>
                </div>
            </div>
            <Week
                days={week}
                calendarEvents={calendarEvents}
                onCalendarEventClick={onCalendarEventClick}
                onCreateClick={onCreateClick}
            />
        </div>
    );
};
